import { render } from "./addCarBaseInfo.vue?vue&type=template&id=6f4d8f0f&scoped=true"
import script from "./addCarBaseInfo.vue?vue&type=script&lang=js"
export * from "./addCarBaseInfo.vue?vue&type=script&lang=js"

import "./addCarBaseInfo.vue?vue&type=style&index=0&id=6f4d8f0f&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4d8f0f"]])

export default __exports__